import script from "./EditorFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorFilters.vue?vue&type=script&setup=true&lang=js"

import "./EditorFilters.vue?vue&type=style&index=0&id=c3a8de86&lang=css"

const __exports__ = script;

export default __exports__